import Decimal from 'decimal.js';

export enum JPDateFormatType {
  YMD = 1,
  YM = 2,
}
export const formatJPDate = (date: string, type: JPDateFormatType) => {
  const dateObj = new Date(date);

  switch (type) {
    case JPDateFormatType.YMD:
      return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月${dateObj.getDate()}日`;
    case JPDateFormatType.YM:
      return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月`;
  }
};

export const formatYenBasedOn10KYen = (num: number) => {
  return `${(num / 10000).toLocaleString()}万円`;
};
export const formatYenBasedOn1MYen = (num: number) => {
  return `${Math.floor(num / 1000000).toLocaleString()}百万円`;
};

export const formatPrice = (num: number | string | null | undefined, emptyStr: string = '-') => {
  if (typeof num === 'string') {
    if (num) {
      return parseInt(num).toLocaleString();
    } else {
      return emptyStr;
    }
  } else {
    if (num === 0) {
      return '0';
    }

    if (num) {
      return num.toLocaleString();
    } else {
      return emptyStr;
    }
  }
};

// 小数点以下第二位を切り捨て
export const formatRate = (num: number) => {
  const decimal = new Decimal(num);
  const truncated = decimal.toDecimalPlaces(2, Decimal.ROUND_DOWN);
  return truncated.toFixed(2);
};

export const enum DateFormatType {
  Slash_yyyyMMdd,
  Japanese_yyyyMd,
}

export const formatDate = (date: Date | null | undefined, formatType: DateFormatType) => {
  if (!date) return '';
  switch (formatType) {
    case DateFormatType.Slash_yyyyMMdd:
      return date.toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' });
    case DateFormatType.Japanese_yyyyMd:
      return date.toLocaleDateString('ja-JP', { year: 'numeric', month: 'short', day: 'numeric' });
  }
};

export const toHalfWidthNumber = (numStr: string) => {
  return numStr.replace(/[０-９]/g, (x) => String.fromCharCode(x.charCodeAt(0) - 0xfee0));
};
